import {
  hasSurveyPlan,
  hasSonicProspectPlan,
} from "./entitlements";
import { isEnterpriseCustomer } from "./platformPricing";
import {
  CONSOLE_HOME_PATH,
  hasCorePlatformPlan,
  resolveConsoleHomePath,
} from "./consoleHome";

/**
 * Settings sidebar top "home" item for SMB: label matches the active product.
 * Core / enterprise VoC home uses My AI Insights (Advisor).
 */
export function resolveSettingsHomeNav({
  user = null,
  subscriptionRow = null,
  t = null,
} = {}) {
  const href = resolveConsoleHomePath(user, subscriptionRow);
  const defaultLabel =
    typeof t === "function"
      ? t("nav.ia_my_ai_insights", "My AI Insights")
      : "My AI Insights";

  if (isEnterpriseCustomer(subscriptionRow)) {
    return {
      href: hasCorePlatformPlan(subscriptionRow)
        ? CONSOLE_HOME_PATH
        : resolveConsoleHomePath(user, subscriptionRow),
      label: defaultLabel,
    };
  }

  if (href.startsWith("/console/sonic-prospect")) {
    return {
      href,
      label:
        typeof t === "function"
          ? t("settings_sidebar.home_sonic_prospect", "Sonic Prospect")
          : "Sonic Prospect",
    };
  }

  if (href.startsWith("/console/sonic-survey") || href.startsWith("/console/feedback-capture")) {
    return {
      href,
      label:
        typeof t === "function"
          ? t("settings_sidebar.home_sonic_survey", "Sonic Survey")
          : "Sonic Survey",
    };
  }

  // SMB with core (or unknown) — My AI Insights / advisor home.
  if (hasCorePlatformPlan(subscriptionRow)) {
    return { href: CONSOLE_HOME_PATH, label: defaultLabel };
  }

  // Entitlement-only fallback when path resolution lacked user.plan hints.
  if (hasSonicProspectPlan(subscriptionRow)) {
    return {
      href: "/console/sonic-prospect",
      label:
        typeof t === "function"
          ? t("settings_sidebar.home_sonic_prospect", "Sonic Prospect")
          : "Sonic Prospect",
    };
  }
  if (hasSurveyPlan(subscriptionRow)) {
    return {
      href: "/console/sonic-survey",
      label:
        typeof t === "function"
          ? t("settings_sidebar.home_sonic_survey", "Sonic Survey")
          : "Sonic Survey",
    };
  }

  return { href, label: defaultLabel };
}
